'use client';

import React from 'react';
import Image from 'next/image';

const BOOK = '/images/comix/homepage/v2/banner-book-desktop.avif';
// Mobile-only: a different photo with its own peach background already baked in.
const BOOK_MOBILE = '/images/comix/homepage/v2/banner-book-mobile.avif';
const BOOK_ALT =
  'An open personalised comic book showing multiple characters across its panels';

/**
 * "Multiple characters. Your storyline." — Figma desktop 303:3362 / mobile 303:2966.
 * Desktop lays the book left of the copy on a white→peach wash; mobile stacks the copy
 * above the book on a peach gradient card.
 */
export default function StoryBanner() {
  // No vertical padding on mobile — the section's own py- was leaving a gap above/below
  // the full-bleed card, undercutting the edge-to-edge effect. Desktop is unaffected.
  return (
    <section id="story-banner" className="w-full py-0 dt:pb-9 dt:pt-[84px]">
      {/* Mobile card: full-bleed, edge to edge (outside hp-container's gutter padding).
          Two independent parts: a text block on its own gradient background, and the
          image block below with no background of its own — the source photo already
          has its background baked in. */}
      <div className="dt:hidden">
        <div
          className="px-4 pb-0 text-center"
          style={{
            backgroundImage: 'linear-gradient(180deg, #F7DAC2 0%, #EFCCAF 100%)',
            paddingTop: '30px',
          }}
        >
          <h2
            className="font-bold tracking-[-0.454px] text-[var(--hp-ink-soft)] opacity-90"
            style={{ fontSize: '26px', lineHeight: 1.35 }}
          >
            Multiple characters.{' '}
            <br />
            Your storyline.
          </h2>
        </div>
        <Image
          src={BOOK_MOBILE}
          alt={BOOK_ALT}
          width={1179}
          height={888}
          className="w-full h-auto"
          sizes="100vw"
        />
      </div>

      <div className="hp-container">
        {/* Desktop card: art left, copy right. The book deliberately overflows the card
            vertically, exactly as it does in Figma. */}
        <div
          className="relative hidden h-[280px] items-center rounded-[10px] dt:flex"
          style={{
            backgroundImage:
              'linear-gradient(111.397deg, rgb(255,255,255) 40.222%, rgb(255,237,223) 87.045%)',
          }}
        >
          <div className="absolute left-0 top-1/2 h-[118%] w-[47.4%] -translate-y-1/2 overflow-hidden">
            <Image
              src={BOOK}
              alt={BOOK_ALT}
              fill
              className="object-cover"
              style={{ objectPosition: '50% 47%' }}
              sizes="(max-width: 1040px) 48vw, 493px"
            />
          </div>
          <h2
            className="ml-auto w-[41.5%] pr-[14.4%] font-bold tracking-[-0.454px] text-[var(--hp-ink-soft)] opacity-90"
            style={{ fontSize: 'var(--hp-banner)', lineHeight: 1.35 }}
          >
            Multiple characters.{' '}
            <br />
            Your storyline.
          </h2>
        </div>
      </div>
    </section>
  );
}
